import React  from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Typography from '@mui/material/Typography';



const LandingBlockFirst = () => {



    return (
        <div className="block-div-first">
            <div className="block-card-first">

                <div className="block-leftCard-first">
                    <div style={{ height: '100%', padding: 10, display: 'flex', flexDirection: 'column', textAlign: 'right', justifyContent: 'center', alignItems: 'flex-start' }}>
                       
                        <Typography variant="h5" component="h1" sx={{
                            color:'#10406B',
                            fontFamily:"'Tajawal', sans-serif",
                            fontStyle:'bold'
                        }} >
                            مرحباً بكً في منصة الضرائب الطبية الالكترونية
                        </Typography>

                        <Typography paragraph={true} component="p"  sx={{
                            marginTop:'10px',
                            color:'#10406B',
                            fontFamily:"'Tajawal', sans-serif",
                            fontSize:'16px',
                            fontStyle:'normal'
                        }} >


                            تم اطلاق المشروع من قبل وزارة الاتصالات / شركة السلام العامة لغرض الإسهام في تبسيط الإجراءات الحكومية في تقديم الخدمات الى المؤسسات و المواطنين عبر التحول الرقمي ضمن أعلى معايير الجودة
                        </Typography>

                    </div>

                </div>
                <div className="block-rightCard-first" >
                    <div style={{ height: '100%',  display: 'flex', flexDirection: 'column', textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                        <img
                            src={`${require('../../../assets/imgs/vector_1.png')}`}
                            alt={"شركة السلام العامة"}
                            loading="lazy"
                            width={"100%"}
                        />
                        
                    </div>

                </div>
            </div>
           
        </div>
    )
}


export default LandingBlockFirst;